import { ThreeDotIcon } from "icons";
import { issueTypeColors, issueTypeIcons } from "../constants";
import styles from "./styles.module.scss";

export const TicketCard = ({ item, handleNext }) => {
  const Icon = issueTypeIcons[item?.issueType];
  return (
    <div className={styles.ticketcardContainer} onClick={handleNext}>
      <div
        className={styles.issueTag}
        style={{ backgroundColor: `${issueTypeColors[item?.issueType]}` }}
      >
        <Icon />
        {item?.issueType}
      </div>
      <div className={styles.subject}>{item?.title}</div>
      <div className={styles.desc}>{item?.desc}</div>
      <div className={styles.footer}>
        <div className={styles.postedAt}>Posted at {item?.postedAt}</div>
        <ThreeDotIcon />
      </div>
    </div>
  );
};
